import { __assign } from "tslib";
import React from 'react';
import { useRangeCalendarState } from 'web-platform-alpha';
import { BaseCalendar } from './BaseCalendar';
export var RangeCalendar = function (props) {
    var state = useRangeCalendarState(props);
    return React.createElement(BaseCalendar, __assign({}, props, { state: state }));
};
